import { has } from 'lodash';
import { ACTIONS } from '../Constants';

const initialState = {
    byId: {},
    filteredById: {},
    loading: false,
    segments: {
        companies: {}
    },
    userFollowsMeta: {
        followerCount: 0,
        isFollowing: false
    }
};

// Segment look up looks like
// segments[segmentType][typeId] = [...documentIds]
const getSegments = (byId) => {
    const initialSegments = {
        companies: {}
    };
    return Object.values(byId).reduce((segments, doc) => {
        if (doc && doc.companyId && doc.companyId !== '' && doc.companyId !== null) {
            if (!has(segments.companies, doc.companyId)) {
                segments.companies[doc.companyId] = [doc._id];
            } else if (!segments.companies[doc.companyId].includes(doc._id)) {
                segments.companies[doc.companyId].push(doc._id);
            }
        }

        return segments;
    }, initialSegments);
};

const profiles = (state = initialState, action) => {
    let currentUserFollowsMeta;
    let newById;
    let newFilteredById;
    let reduced;

    switch (action.type) {
        case ACTIONS.GET_PROFILE_STARTED:
            return {
                ...state,
                loading: true
            };
        case ACTIONS.GET_PROFILE:
        case ACTIONS.UPDATE_PROFILE:
        case ACTIONS.PUT_PROFILE_COLLECTION:
        case ACTIONS.PUT_LAST_SIGN_IN_DATETIME: {
            const { profile } = action.payload;
            newById = {
                ...state.byId,
                [profile._id]: profile
            };
            return {
                ...state,
                byId: newById,
                loading: false,
                segments: getSegments(newById)
            };
        }
        case ACTIONS.GET_MANY_PROFILES:
        case ACTIONS.GET_COMPANY_MEMBERS:
        case ACTIONS.ADD_COMPANY_MEMBERS_SUCCESS:
        case ACTIONS.REMOVE_COMPANY_MEMBERS_SUCCESS: {
            const { profiles } = action.payload;
            reduced = profiles.reduce((prev, profile) => {
                prev[profile._id] = profile;
                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById,
                segments: getSegments(newById)
            };
        }
        case ACTIONS.GET_FILTERED_PROFILES: {
            const { profiles } = action.payload;
            reduced = profiles.reduce((prev, profile) => {
                prev[profile._id] = profile;
                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced
            };

            return {
                ...state,
                byId: newById,
                filteredById: reduced,
                segments: getSegments(newById)
            };
        }
        case ACTIONS.UPDATE_SEARCHED_USER_PROFILES: {
            return {
                ...state,
                filteredById: action?.payload?.profiles?.filteredById
            };
        }
        case ACTIONS.POST_SEARCHED_USER_PROFILES: {
            reduced = action.payload.profiles.reduce((prev, profile) => {
                prev[profile._id] = profile;
                return prev;
            }, {});

            newFilteredById = {
                ...state.filteredById,
                ...reduced
            };

            return {
                ...state,
                filteredById: newFilteredById,
                sortOrder: action.payload.sortOrder,
                loading: false
            };
        }

        case ACTIONS.GET_FOLLOWERS:
            return {
                ...state,
                followingUser: action.payload.followingUsers
            };
        case ACTIONS.GET_FOLLOWING:
            return {
                ...state,
                userFollows: action.payload.userFollows
            };
        case ACTIONS.GET_USERFOLLOWS_META:
            return {
                ...state,
                userFollowsMeta: action.payload.userFollowsMeta
            };

        // For optimistic UI, we can alter the UI manually to give the
        // impression that it was immediate. If the post fails, it will revert back
        case ACTIONS.POST_USERFOLLOW_START:
            currentUserFollowsMeta = state.userFollowsMeta;
            return {
                ...state,
                userFollowsMeta: {
                    ...currentUserFollowsMeta,
                    followerCount: currentUserFollowsMeta.followerCount + 1,
                    isFollowing: true
                }
            };

        // For optimistic UI, we can alter the UI manually to give the
        // impression that it was immediate. If the post fails, it will revert back
        case ACTIONS.DELETE_USERFOLLOW_START:
            currentUserFollowsMeta = state.userFollowsMeta;
            return {
                ...state,
                userFollowsMeta: {
                    ...currentUserFollowsMeta,
                    followerCount: currentUserFollowsMeta.followerCount - 1,
                    isFollowing: false
                }
            };

        case ACTIONS.CLEAR_PROFILES: {
            return {
                ...state,
                byId: {}
            };
        }

        case ACTIONS.CLEAR_SEARCHED_PROFILES:
            return {
                ...state,
                filteredById: {}
            };

        case ACTIONS.DELETE_PROFILE: {
            const { id } = action.payload;
            newById = { ...state.byId };
            const newFilteredById = { ...state.filteredById };
            if (id in newById) {
                delete newById[id];
            }
            if (id in newFilteredById) {
                delete newFilteredById[id];
            }
            return {
                ...state,
                byId: newById,
                filteredById: newFilteredById
            };
        }

        case ACTIONS.REAL_DELETE_PROFILES: {
            // nothing to update.
            return {
                ...state
            };
        }

        default:
            return state;
    }
};

export default profiles;
